/**
 * @format
 */
angular
    .module("autoremind.communications")
    .directive("communicationsTargetTriggered", [
    "jobService",
    "$log",
    function (jobService, $log) {
        return {
            restrict: "E",
            scope: true,
            templateUrl: "app/communication/forms/communications-target-triggered.html",
            link: function (scope) {
                scope.APPOINTMENT = jobService.APPOINTMENT_TRIGGER;
                scope.ORDERS = jobService.ORDERS_TRIGGER;
                scope.firstTarget = scope.job.targets[0];
                const keys = {
                    REMOTE_ITEM_TYPES: "remoteItemTypes",
                    REMOTE_ITEM_STATES: "remoteItemStates",
                    LOCATION_TYPES: "locationTypes",
                    LOCATION: "locations",
                    DAYS_IN_STATE: "daysInState",
                    TRACKABLE_ITEM_CATEGORY: "trackableItemCategoryId",
                    TYPE: "type",
                };
                scope.triggerModel = {
                    selectedReasonId: null,
                    selectedItemType: null,
                    selectedState: null,
                    selectedLocationType: null,
                    selectedLocation: null,
                    selectedSendMode: "immediately",
                    selectedDaysInState: 1,
                };
                scope.selected = {
                    itemTypes: new Set([]),
                    states: new Set([]),
                    locationTypes: new Set([]),
                    locations: new Set([]),
                };
                scope.$watch("selectedTriggeredMessageType", function () {
                    if (scope.selectedTriggeredMessageType === scope.ORDERS) {
                        scope.initializeOrdersView();
                    }
                    if (scope.selectedTriggeredMessageType === scope.APPOINTMENT) {
                        scope.initializeAppointmentView();
                    }
                });
                scope.initializeOrdersView = function () {
                    scope.getItemTypes();
                    scope.getStates();
                    scope.getLocations();
                    scope.getLocationTypes();
                    if (Boolean(scope.triggerJob.trackableItemCategoryId)) {
                        jobService.job.jobContent.targets = scope.triggerJob.targets;
                        jobService.job.jobContent.triggerSetting = scope.triggerJob.triggerSetting;
                        var target = scope.triggerJob.targets[0];
                        if (target[keys["REMOTE_ITEM_TYPES"]] && target[keys["REMOTE_ITEM_TYPES"]].length > 0) {
                            scope.selected.itemTypes = new Set(target[keys["REMOTE_ITEM_TYPES"]]);
                        }
                        if (Boolean(target[keys["REMOTE_ITEM_STATES"]]) && target[keys["REMOTE_ITEM_STATES"]].length > 0) {
                            scope.selected.states = new Set(target[keys["REMOTE_ITEM_STATES"]]);
                        }
                        if (Boolean(target[keys["LOCATION_TYPES"]]) && target[keys["LOCATION_TYPES"]].length > 0) {
                            scope.selected.locationTypes = new Set(target[keys["LOCATION_TYPES"]]);
                        }
                        if (Boolean(target[keys["LOCATION"]]) && target[keys["LOCATION"]].length > 0) {
                            scope.selected.locations = new Set(target[keys["LOCATION"]]);
                        }
                        if (Boolean(target[keys["DAYS_IN_STATE"]]) && target[keys["DAYS_IN_STATE"]] > 0) {
                            scope.triggerModel.selectedDaysInState = target[keys["DAYS_IN_STATE"]];
                            scope.triggerModel.selectedSendMode = "afterDays";
                            jobService.disableTriggerHoursDropDown = false;
                        }
                        else {
                            scope.triggerModel.selectedSendMode = "immediately";
                            jobService.disableTriggerHoursDropDown = true;
                        }
                    }
                    else {
                        jobService.job.jobContent.targets = [];
                        jobService.job.jobContent.triggerSetting = {
                            intervalMinutes: 15,
                            triggerType: "interval",
                        };
                        jobService.disableTriggerHoursDropDown = true;
                    }
                    scope.updateTargetJobByKey(keys["TYPE"], "triggered-trackableitem");
                    if (scope.triggerModel.selectedSendMode === "immediately") {
                        scope.updateTargetJobByKey(keys["DAYS_IN_STATE"], 0);
                    }
                    else {
                        scope.updateTargetJobByKey(keys["DAYS_IN_STATE"], scope.triggerModel.selectedDaysInState || 0);
                    }
                    if (Boolean(scope.currentItemCategory)) {
                        scope.updateTargetJobByKey(keys["TRACKABLE_ITEM_CATEGORY"], scope.currentItemCategory.itemCategoryId);
                    }
                };
                scope.initializeAppointmentView = function () {
                    jobService.disableTriggerHoursDropDown = false;
                    if (Boolean(scope.triggerJob.targets) && !Boolean(scope.triggerJob.trackableItemCategoryId)) {
                        jobService.job.jobContent.targets = scope.triggerJob.targets;
                        jobService.job.jobContent.triggerSetting = scope.triggerJob.triggerSetting;
                    }
                    else {
                        jobService.job.jobContent.targets = [
                            {
                                type: "triggered",
                                remoteAppointmentState: null,
                                acceptAppointmentStates: ["scheduled", "confirmed"],
                                triggerOffset: 1,
                            },
                        ];
                    }
                };
                scope.targetsHasReasonAlready = function () {
                    for (var x in scope.job.targets) {
                        if (scope.job.targets[x].reasonId === scope.triggerModel.selectedReasonId) {
                            return true; // Don't add the same reason twice
                        }
                    }
                    return false;
                };
                scope.addTypeToSelected = function () {
                    if (Boolean(scope.triggerModel.selectedItemType) &&
                        !scope.selected.itemTypes.has(scope.triggerModel.selectedItemType)) {
                        scope.selected.itemTypes.add(scope.triggerModel.selectedItemType);
                        const targetArray = Array.from(scope.selected.itemTypes);
                        console.log(keys["REMOTE_ITEM_TYPES"]);
                        scope.updateTargetJobByKey(keys["REMOTE_ITEM_TYPES"], targetArray);
                    }
                };
                scope.removeItemTypeFromSelected = function (targetValue) {
                    if (Boolean(targetValue) && scope.selected.itemTypes.delete(targetValue)) {
                        const targetArray = Array.from(scope.selected.itemTypes);
                        scope.updateTargetJobByKey(keys["REMOTE_ITEM_TYPES"], targetArray);
                    }
                };
                scope.addStateToSelected = function () {
                    if (Boolean(scope.triggerModel.selectedState) &&
                        !scope.selected.states.has(scope.triggerModel.selectedState)) {
                        scope.selected.states.add(scope.triggerModel.selectedState);
                        const targetArray = Array.from(scope.selected.states);
                        scope.updateTargetJobByKey(keys["REMOTE_ITEM_STATES"], targetArray);
                    }
                };
                scope.removeStateFromSelected = function (targetValue) {
                    if (Boolean(targetValue) && scope.selected.states.delete(targetValue)) {
                        const targetArray = Array.from(scope.selected.states);
                        scope.updateTargetJobByKey(keys["REMOTE_ITEM_STATES"], targetArray);
                    }
                };
                scope.addLocationTypeToSelected = function () {
                    if (Boolean(scope.triggerModel.selectedLocationType) &&
                        !scope.selected.locationTypes.has(scope.triggerModel.selectedLocationType)) {
                        scope.selected.locationTypes.add(scope.triggerModel.selectedLocationType);
                        const targetArray = Array.from(scope.selected.locationTypes);
                        scope.updateTargetJobByKey(keys["LOCATION_TYPES"], targetArray);
                    }
                };
                scope.removeLocationTypeFromSelected = function (targetValue) {
                    if (Boolean(targetValue) && scope.selected.locationTypes.delete(targetValue)) {
                        const targetArray = Array.from(scope.selected.locationTypes);
                        scope.updateTargetJobByKey(keys["LOCATION_TYPES"], targetArray);
                    }
                };
                scope.addLocationToSelected = function () {
                    if (Boolean(scope.triggerModel.selectedLocation) &&
                        !scope.selected.locations.has(scope.triggerModel.selectedLocation)) {
                        scope.selected.locations.add(scope.triggerModel.selectedLocation);
                        const targetArray = Array.from(scope.selected.locations);
                        scope.updateTargetJobByKey(keys["LOCATION"], targetArray);
                    }
                };
                scope.removeLocationFromSelected = function (targetValue) {
                    if (Boolean(targetValue) && scope.selected.locations.delete(targetValue)) {
                        const targetArray = Array.from(scope.selected.locations);
                        scope.updateTargetJobByKey(keys["LOCATION"], targetArray);
                    }
                };
                /**
                 *  RADIO BUTTONS
                 */
                scope.sendModeHasChanged = function () {
                    if (scope.triggerModel.selectedSendMode === "immediately") {
                        scope.updateTargetJobByKey(keys["DAYS_IN_STATE"], 0);
                        jobService.disableTriggerHoursDropDown = true;
                        jobService.job.jobContent.triggerSetting = {
                            intervalMinutes: 15,
                            triggerType: "interval",
                        };
                    }
                    else {
                        scope.triggerModel.selectedDaysInState = !scope.triggerModel.selectedDaysInState || scope.triggerModel.selectedDaysInState === 0 ? 1 : scope.triggerModel.selectedDaysInState;
                        scope.updateTargetJobByKey(keys["DAYS_IN_STATE"], scope.triggerModel.selectedDaysInState);
                        jobService.disableTriggerHoursDropDown = false;
                        if (jobService.job.jobContent.triggerSetting.triggerHour === undefined) {
                            jobService.job.jobContent.triggerSetting = {
                                triggerType: "hourOfDay",
                                triggerHour: 9,
                            };
                        }
                    }
                };
                // end RADIO BUTTONS
                scope.getSelectedTypes = function () {
                    return Array.from(scope.selected.itemTypes);
                };
                scope.getSelectedStates = function () {
                    return Array.from(scope.selected.states);
                };
                scope.getSelectedLocationsTypes = function () {
                    return Array.from(scope.selected.locationTypes);
                };
                scope.getSelectedLocations = function () {
                    return Array.from(scope.selected.locations);
                };
                /**
                 * Add new target. Ensure that there is either one default (and only one reason) or if other reasons then no default.
                 * These visible targets are added after the first settings target that has no reasonId defined
                 */
                scope.addToTargetGroup = function () {
                    console.log("addToTargetGroup: " + target);
                    if (!angular.isDefined(scope.triggerModel.selectedReasonId) ||
                        scope.triggerModel.selectedReasonId === "undefined") {
                        return;
                    }
                    if (scope.triggerModel.selectedReasonId === null) {
                        scope.job.jobContent.targets.splice(1); // Delete all targets after first (settings) target
                    }
                    else {
                        // If first visible target (after settings target) is default then delete that before adding new target
                        if (scope.job.jobContent.targets.length === 2 &&
                            scope.job.jobContent.targets[1].reasonId === null) {
                            scope.job.jobContent.targets.splice(1, 1); // Delete target with default reason
                        }
                    }
                    if (!scope.targetsHasReasonAlready(scope.triggerModel.selectedReasonId)) {
                        // Don't add the same reason twice
                        var target = {
                            type: "triggered",
                            reasonId: scope.triggerModel.selectedReasonId,
                        };
                        scope.job.jobContent.targets.push(target);
                    }
                    scope.job.updateTargets();
                };
                scope.removeReasonTarget = function (target) {
                    for (var i = 0; i < jobService.job.jobContent.targets.length; ++i) {
                        if (jobService.job.jobContent.targets[i] === target) {
                            jobService.job.jobContent.targets.splice(i, 1);
                        }
                    }
                    jobService.job.updateTargets();
                };
                scope.updateTargets = function () {
                    scope.job.updateTargets();
                };
                scope.updateTargetJobByKey = function (targetKey, targetValue) {
                    jobService.job.jobContent.targets = [
                        Object.assign(Object.assign({}, jobService.job.jobContent.targets[0]), { [targetKey]: targetValue }),
                    ];
                    // the instruction bellow don't updated job is only mark job as edited
                    jobService.job.updateTargets();
                };
            },
        };
    },
]);
//# sourceMappingURL=communications-target-triggered.js.map